module.exports = __webpack_public_path__ + "static/media/1POLICY36.0e263689.jpg";